import { userRequest } from "./requestMethods";

/**
 * POST /api/catalog/cart-line: "Add to cart" on a /shop grid card.
 *
 * The server turns one catalogue product into a cart line for its own vendor,
 * priced and checked today (services/catalog/catalogCartLine.js), or says what
 * the card should do instead (see a size, ask for a quote, or why it cannot be
 * had). The request carries ids only, never a price. userRequest attaches the
 * session token only when there is one, so a signed-in trade buyer is priced
 * at their tier and a guest at the public price (the route is optionalAuth).
 *
 * @param {{ productId: string, outletId?: string|null }} args  `outletId` is
 *        the branch the shopper's cart for this brand is already at, if any
 * @returns {Promise<object>} the server's answer
 */
export const requestCatalogCartLine = async ({ productId, outletId = null }) => {
  const response = await userRequest.post("/api/catalog/cart-line", {
    productId,
    ...(outletId ? { outletId } : {}),
  });
  return response.data;
};

export default requestCatalogCartLine;
